export default class Marque {
  name: string = "";
  id: string = "";
}
